/**
 * Pulls the signed `token` query param out of a recording playback URL
 * (issue #649). The backend mints the token into every playbackUrl; the
 * anonymous view-count path reuses it as proof of playback intent, so an
 * anonymous viewer can only count a view for a recording they could
 * actually play.
 */
export function extractPlaybackToken(playbackUrl: string | null): string | null {
  if (!playbackUrl) return null;
  try {
    const token = new URL(playbackUrl).searchParams.get('token');
    return token && token.length > 0 ? token : null;
  } catch {
    return null;
  }
}
